import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow, TableCell, Box, Typography } from '@mui/material';
import { formatDate } from '../../../../utils/formatDate';
import { useSelector } from 'react-redux';

export const HistoryTableBody = ({ data }) => {

  const { companyBonuses, branches, triggers: bonusTypes, cms } = useSelector((state) => state.bonuses);
  const { triggers } = useSelector((state) => state.logging);

  const findServiceName = (id) => {
    let res = [];
    companyBonuses.forEach(item => item.services.forEach(service => {
      if (service.id === id) {
        res[0] = item.name;
        res[1] = service.name;
      }
    }));
    return res;
  };

  const findCityName = (id) => branches?.filter(city => city.id === +id)[0]?.label;

  const findPackage = (id) => cms?.filter(item => item.id === id)[0]?.name;

  const parseMessage = (message, trigger_id) => {
    if (message) {
      if (message.status && (message.status === 'Активна' || message.status === 'Архив' || message.status === 'На одобрении' || message.status === 'Одобрена'))
        return [`Изменяет статус события на ${message.status}`];
      if (message.status && message.status === 'Доработка') return [`Изменяет статус события на ${message.status} по причине:`, `"${message.reason}"`];
      else {
        const bonusType = message?.trigger_id ? bonusTypes?.filter(type => type?.id === message?.trigger_id)[0]?.slug : undefined;
        const trigger = triggers.filter(trigger => trigger.id === trigger_id)[0]?.slug;
        const fields = [];
        const values = [];
        const resultMessage = [];
        let triggerName;
        let filesNames = '';

        Object.keys(message).forEach(key => {
          switch (key) {
            case 'trigger_id':
              fields.push('Триггер');
              switch (bonusType) {
                case 'active':
                  triggerName = 'Активация upsell бонусов';
                  break;
                case 'welcome':
                  triggerName = 'Welcome бонус';
                  break;
                case 'retention':
                  triggerName = 'Программа удержания абонентов';
                  break;
                case 'crm':
                  triggerName = 'Обоснованная жалоба CRM';
                  break;
              }
              values.push(triggerName);
              break;
            case 'bonus_add':
              fields.push('Количество бонусов');
              values.push(message[key]);
              break;
            case 'terms':
              fields.push('Условия');
              values.push(message[key]);
              break;
            case 'date_start':
              fields.push('Дата старта');
              values.push(formatDate(message[key]));
              break;
            case 'date_end':
              fields.push('Дата окончания');
              values.push(formatDate(message[key], true));
              break;
            case 'date_expiry':
              fields.push('Срок действия бонусов до');
              values.push(formatDate(message[key], true));
              break
            case 'service_id':
              fields.push('Название кампании');
              values.push(findServiceName(message[key])[0]);
              fields.push('Название акции');
              values.push(findServiceName(message[key])[1]);
              break;
            // UNDONE: Temporary not showing, Task=382736
            // case 'packages_validation':
            //   if (bonusType && bonusType === 'active' || !bonusType) {
            //     fields.push('Проверка совместимости бонусов');
            //     values.push(message[key][0]);
            //   }
            //   break;
            // case 'activation_conditions':
            //   if (bonusType && bonusType === 'active' || !bonusType) {
            //     fields.push('Условия активации');
            //     values.push(message[key][0]);
            //   }
            //   break;
            case 'to_all_customer':
              if (bonusType && bonusType !== 'retention' || !bonusType) {
                fields.push('Начислить абонентам');
                values.push(message[key] ? 'Всем' : 'Загрузить файл');
              }
              break;
            case 'customer_files':
              if (typeof message.to_all_customer === 'undefined') resultMessage.push('Добавил файл(-ы)');
              break;
            case 'add_if_debt_exist':
              fields.push('Начислять при наличии задолженности по услугам постоплаты');
              values.push(message[key] ? 'Да' : 'Нет');
              break;
            case 'city_ids':
            case 'city_id':
              if (bonusType && bonusType === 'welcome' || !bonusType) {
                fields.push('Города');
                let cityValue = '';
                message[key].forEach((city, index, array) => {
                  cityValue += findCityName(city);
                  if (index !== array.length - 1) cityValue += ', ';
                })
                values.push(cityValue);
              }
              break;
            case 'package_id':
              if (bonusType !== 'crm') {
                fields.push('Пакет');
                values.push(findPackage(message[key]));
              }
              break;
            case 'customers_limit':
              if (bonusType === 'retention') {
                fields.push('Количество абонентов');
                values.push(message[key]);
              }
              break;
            case 'customer_file_names':
              fields.push('Загружает файлы');
              message[key].forEach((file, index, array) => {
                filesNames += `"${file}"`;
                if (index !== array.length - 1) filesNames += ', ';
              });
              values.push(filesNames);
              break;
          }
        });

        if (!fields.length && resultMessage.length) return resultMessage;
        else if (fields.length === 1) return [`Изменяет поле ${fields[0]} на ${values[0]}`];
        else {
          resultMessage.push(trigger === 'post_bonuses_card' ? 'Создает карточку с полями:' : 'Изменяет поля');
          fields.forEach((field, index) => {
            resultMessage.push(trigger === 'post_bonuses_card' ? `${field}: ${values[index]}` : `${field} на ${values[index]}`);
          });
          return resultMessage;
        }
      }
    }
  }

  return (
    <TableBody>
      {data?.map((item) => {
        const parsedMessage = parseMessage(item?.message?.payload, item?.trigger_id);
        return parsedMessage?.length && (
          <TableRow
            key={`history${item.id}`}
          >
            <TableCell>
              <Box width="130px">{formatDate(item.created_at, true)}</Box>
            </TableCell>

            <TableCell>
              <Box width="90px">{formatDate(item.created_at, false, true)}</Box>
            </TableCell>

            <TableCell sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
              <Box sx={{ fontWeight: 500 }}
                   minWidth="235px">{item?.message?.author?.fullname === 'System' ? 'Система' : item?.message?.author?.fullname}</Box>
            </TableCell>

            <TableCell sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
              <Box maxWidth="500px"
                   minWidth="350px">{parsedMessage?.map(item => <Typography
                key={item}>{item}</Typography>)}</Box>
            </TableCell>
          </TableRow>
        )
      })}
    </TableBody>
  );
};

HistoryTableBody.propTypes = {
  data: PropTypes.array
};
